<strong class="text-danger" *ngFor="let moy of moyennes"> {{moy.moyenne  | number:'2.0-2'}} </strong>
